if (!customElements.get('top-sticky-atc-panel')) {
    class TopStickyAtcPanel extends HTMLElement {
        constructor() {
            super();
            this.observer = null;

            /*if ('IntersectionObserver' in window && 'MutationObserver' in window) {
                this.bindEvents();
            }*/
        }

        connectedCallback() {
            this.init();
        }

        init() {
            // Define main DOM nodes
            this.productSection = this.closest('.cc-main-product, .cc-featured-product');
            if (!this.productSection) return;

            this.productInfo = this.productSection.querySelector('.product-info, .has-sticky-atc');
            this.productForm = this.productSection.querySelector('product-form');
            this.variantPicker = this.productSection.querySelector('variant-picker');
            this.stickyAtcBtn = this.querySelector('.sticky-atc');

            if (this.stickyAtcBtn) {
                this.stickyAtcOriginalText = this.stickyAtcBtn.textContent.trim();
            }

            this.renderVariants();
            this.bindEvents();
            this.syncStickyAtcText();
            setTimeout(() => {
                this.updateStickyImage(this.variantPicker ? this.variantPicker.variant : null);
            }, 1);
        }

        /**
         * Collects variant data
         */
        getVariantData() {
            if (!this.variantPicker) return {};

            const optionsByName = {};

            this.variantPicker.querySelectorAll('.option-selector').forEach(selector => {
                selector.querySelectorAll('input').forEach(input => {

                    const optionName = input.dataset.optionName;
                    if (!optionName) return;

                    const label = selector.querySelector(`label[for="${input.id}"]`);

                    const swatch = label ? label.dataset.swatch : null;
                    const swatchImage = label ? label.dataset.swatchImage : null;

                    const optionWrapper = input.closest('.option-wrapper');
                    const isHidden = optionWrapper ? window.getComputedStyle(optionWrapper).display === 'none' : false;

                    if (!optionsByName[optionName]) {
                        optionsByName[optionName] = [];
                    }

                    optionsByName[optionName].push({
                        id: input.id,
                        value: input.value,
                        checked: input.checked,
                        unavailable: input.classList.contains('is-unavailable'),
                        swatch: swatch,
                        swatchImage: swatchImage,
                        hidden: isHidden
                    });
                });
            });

            return optionsByName;
        }

        /**
         * Collects variant labels
         */
        getVariantLabels() {
            if (!this.variantPicker) return {};

            const labelsByName = {};

            this.variantPicker.querySelectorAll('.option-selector').forEach(selector => {
                selector.querySelectorAll('input').forEach(input => {
                    const optionName = input.dataset.optionName;
                    if (!optionName || !input.id) return;

                    const label = selector.querySelector(`label[for="${input.id}"]`);
                    if (!label) return;

                    if (!labelsByName[optionName]) {
                        labelsByName[optionName] = [];
                    }

                    labelsByName[optionName].push({
                        id: input.id,
                        label
                    });
                });
            });

            return labelsByName;
        }

        /**
         * Renders variants inside the sticky panel
         */
        renderVariants() {
            const cardVariants = this.querySelector('.card__variants');
            const cardInfo = this.querySelector('.card__info');
            if (!cardInfo) return;

            const options = this.getVariantData();
            if (!options || Object.keys(options).length === 0) return;

            const labelsByName = this.getVariantLabels();

            const container = cardVariants || document.createElement('div');
            container.className = 'card__variants';

            container.innerHTML = Object.entries(options)
                .sort(([nameA], [nameB]) => {
                    if (nameA === 'Fit') return 1;
                    if (nameB === 'Fit') return -1;
                    return 0;
                })
                .map(([optionName, optionValues]) => {
                    const selected = optionValues.find(opt => opt.checked);
                    const selectedValue = selected
                        ? selected.value.replace(/-Pack$/, '')
                        : '';

                    let selectedColorHTML = '';

                    const valuesHTML = optionValues
                        .map(opt => {
                            const html = `
                              <span 
                                class="card__variant-value${opt.checked ? ' is-active' : ''}${opt.unavailable ? ' is-disabled' : ''}${optionName === 'Color' ? ' opt-label--swatch' : ''} opt-label opt-label--btn relative text-center"
                                data-id="${opt.id}"
                                ${opt.swatch ? `data-swatch="${opt.swatch}"` : ''}
                                ${opt.swatchImage ? `data-swatch-image="${opt.swatchImage}"` : ''}
                                data-option="${optionName}"
                                ${opt.hidden ? `hidden` : ''}
                              >${(opt.swatch || opt.swatchImage) ? '' : opt.value}</span>
                            `;
                            if (optionName === 'Color' && opt.checked) {
                                selectedColorHTML = html;
                            }
                             return html;
                        })
                        .join('');

                    const valuesClass = optionValues.length > 12 ? 'card__variant-values card__variant-values--grid' : 'card__variant-values';

                    return `
                        <div class="card__variant" data-option="${optionName}">
                          <div class="card__variant-name">
                            ${optionName}:
                            ${selected ? `<span class="card__variant-selected">${selectedColorHTML || selectedValue}</span>` : ''}
                            <button class="card__variant-dropdown-button" aria-haspopup="true" aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2232 3.1753C11.1675 3.11942 11.1013 3.07509 11.0284 3.04484C10.9555 3.01459 10.8773 2.99902 10.7984 2.99902C10.7195 2.99902 10.6413 3.01459 10.5685 3.04484C10.4956 3.07509 10.4293 3.11942 10.3736 3.1753L5.99841 7.5517L1.62321 3.1753C1.51055 3.06263 1.35775 2.99934 1.19841 2.99934C1.03908 2.99934 0.886278 3.06263 0.773614 3.1753C0.66095 3.28796 0.597656 3.44077 0.597656 3.6001C0.597656 3.75943 0.66095 3.91223 0.773614 4.0249L5.57361 8.8249C5.62935 8.88077 5.69556 8.9251 5.76845 8.95535C5.84135 8.9856 5.91949 9.00117 5.99841 9.00117C6.07734 9.00117 6.15548 8.9856 6.22837 8.95535C6.30127 8.9251 6.36748 8.88077 6.42321 8.8249L11.2232 4.0249C11.2791 3.96916 11.3234 3.90295 11.3537 3.83006C11.3839 3.75716 11.3995 3.67902 11.3995 3.6001C11.3995 3.52118 11.3839 3.44303 11.3537 3.37014C11.3234 3.29724 11.2791 3.23103 11.2232 3.1753Z" fill="white"/>
                                </svg>
                            </button>
                          </div>
                          <div class="${valuesClass}" data-title="Select ${optionName.toLowerCase()}">
                            ${valuesHTML}
                          </div>
                        </div>
                      `;
                })
                .join('');

            if (!cardVariants) {
                cardInfo.appendChild(container);
            }
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', TopStickyAtcPanel.handleScroll);
        }

        bindEvents() {
            const observer = new IntersectionObserver((entries) => {
                let formVisible = false;
                let infoVisible = false;

                entries.forEach((entry) => {
                    if (entry.target === this.productForm) {
                        formVisible = entry.isIntersecting;
                    }
                    if (entry.target === this.productInfo) {
                        infoVisible = entry.isIntersecting;
                    }
                });
                this.updateStickyState(formVisible, infoVisible);
            });


            if (this.productForm) observer.observe(this.productForm);
            if (this.productInfo) observer.observe(this.productInfo);

            this.scrollHandler = () => {
                if (window.scrollY < 600) {
                    this.updateStickyState();
                }
                document.body.classList.toggle(
                    'scrolled-to-bottom',
                    window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
                );
            };

            window.addEventListener('scroll', this.scrollHandler, { passive: true });
            this.scrollHandler();

            this.addEventListener('click', (e) => {
                // --- variant value ---
                const valueEl = e.target.closest('.card__variant-value');
                if (valueEl) {
                    this.triggerVariantValue(valueEl);
                    return;
                }

                // --- sticky ATC ---
                const atcBtn = e.target.closest('.sticky-atc');
                if (atcBtn) {
                    this.triggerAtc(e);
                    return;
                }

                // --- dropdown variants ---
                const dropdownBtn = e.target.closest('.card__variant-name');
                if (dropdownBtn) {
                    this.toggleVariantDropdown(dropdownBtn);
                }
            });

            document.addEventListener('click', (e) => {
                const isInsideVariant = e.target.closest('.card__variant-name');
                const isInsideValues = e.target.closest('.card__variant-values');

                if (!isInsideValues && !isInsideVariant) {
                    this.querySelectorAll('.card__variant-values').forEach(v => v.classList.remove('active'));
                    this.querySelectorAll('.card__variant-dropdown-button').forEach(b => b.setAttribute('aria-expanded', 'false'));
                }
            });

            if (this.productForm) {
                this.productForm.addEventListener('change', () => {
                    this.syncStickyAtcText();
                });
            }

            this.productSection.addEventListener('on:variant:change', (e) => {
                this.updateStickyImage(e.detail.variant);
            });
        }

        updateStickyState(formVisible = false, infoVisible = false) {
            if (window.scrollY < 600) {
                this.classList.add('top-sticky-atc-panel--out');
                return;
            }

            const shouldHide = formVisible || infoVisible;
            this.classList.toggle('top-sticky-atc-panel--out', shouldHide);
        }

        /**
         * Detects scroll close to the bottom of the page
         */
        static handleScroll() {
            document.body.classList.toggle(
                'scrolled-to-bottom',
                window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
            );
        }

        /**
         * Proxies click to the main product form
         */
        triggerAtc(e) {
            e.preventDefault();
            if (!this.stickyAtcBtn || this.stickyAtcBtn.classList.contains('is-loading')) return;

            if (window.innerWidth <= 1800) {
                const anchorSelector = this.stickyAtcBtn.getAttribute('data-anchor');
                const anchorElement = document.querySelector(anchorSelector);

                if (anchorElement) {
                    anchorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    return;
                }
            }

            const formId = this.stickyAtcBtn.getAttribute('data-product-form-id');
            const form = document.getElementById(formId);
            if (!form) return;

            const submitBtn = form.querySelector('button[type="submit"]');
            if (!submitBtn) return;

            if (submitBtn.disabled) {
                submitBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                this.stickyAtcBtn.classList.add('is-loading');
                submitBtn.click();

                setTimeout(() => {
                    this.stickyAtcBtn.classList.remove('is-loading');
                }, 2000);
            }
        }

        toggleVariantDropdown(button) {
            const parentCard = button.closest('.card__variant');
            if (!parentCard) return;

            const values = parentCard.querySelector('.card__variant-values');
            if (!values) return;

            this.querySelectorAll('.card__variant-values').forEach(v => {
                if (v !== values) v.classList.remove('active');
            });

            this.querySelectorAll('.card__variant-dropdown-button').forEach(b => {
                if (b !== button) b.setAttribute('aria-expanded', 'false');
            });

            const isActive = values.classList.toggle('active');
            button.querySelector('.card__variant-dropdown-button').setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        triggerVariantValue(valueEl) {
            const id = valueEl.dataset.id;
            if (!id) return;

            const input = document.getElementById(id);
            if (!input || input.disabled) return;

            input.click();
        }

        syncStickyAtcText() {
            if (!this.productForm || !this.stickyAtcBtn) return;

            const submitBtn = this.productForm.querySelector('button[type="submit"]');
            if (!submitBtn) return;

            const updateText = () => {
                const isHidden = submitBtn.hasAttribute('hidden') ||
                    submitBtn.hidden ||
                    window.getComputedStyle(submitBtn).display === 'none';

                const isDisabled = submitBtn.disabled;

                if (isDisabled || isHidden) {
                    this.stickyAtcBtn.textContent = "Out of stock";
                    this.stickyAtcBtn.disabled = true;
                } else {
                    this.stickyAtcBtn.textContent = this.stickyAtcOriginalText;
                    this.stickyAtcBtn.disabled = false;
                }
            };

            updateText();

            if (this.buttonObserver) this.buttonObserver.disconnect();

            this.buttonObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' &&
                        ['disabled', 'hidden', 'class', 'style'].includes(mutation.attributeName)) {
                        updateText();
                    }
                });
            });

            this.buttonObserver.observe(submitBtn, {
                attributes: true,
                attributeFilter: ['disabled', 'hidden', 'class', 'style']
            });

        }

        updateStickyImage(variant) {
            const cardMediaImg = this.querySelector('.card__media img');
            if (!cardMediaImg) return;
            if (!variant || !variant.featured_image) return;

            const newSrc = variant.featured_image.src;
            if (newSrc && cardMediaImg.getAttribute('src') !== newSrc) {
                cardMediaImg.src = newSrc;
                cardMediaImg.srcset = newSrc;
            }
        }
    }


    customElements.define('top-sticky-atc-panel', TopStickyAtcPanel);
}